import { SubscriptionState, SubscriptionTier } from "../../proto/api_pb";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const tierStorageMap: Record<
  number,
  { storageValue: number; displayText: string }
> = {
  [SubscriptionTier.SUBSCRIPTION_TIER_PRO]: {
    displayText: "100GB",
    storageValue: 100,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_MINOR]: {
    displayText: "100GB",
    storageValue: 100,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_MAJOR]: {
    displayText: "500GB",
    storageValue: 500,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_STUDIO]: {
    displayText: "1TB",
    storageValue: 1000,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_FREE]: {
    displayText: "100GB",
    storageValue: 100,
  },
};

export const tierMap: Record<number, string> = {
  [SubscriptionTier.SUBSCRIPTION_TIER_PRO]: "Pro",
  [SubscriptionTier.SUBSCRIPTION_TIER_MINOR]: "Minor",
  [SubscriptionTier.SUBSCRIPTION_TIER_MAJOR]: "Major",
  [SubscriptionTier.SUBSCRIPTION_TIER_STUDIO]: "Studio",
  [SubscriptionTier.SUBSCRIPTION_TIER_FREE]: "Free",
  [SubscriptionTier.SUBSCRIPTION_TIER_UNSPECIFIED]: "Unspecified",
};

export const stateMap: Record<number, string> = {
  [SubscriptionState.SUBSCRIPTION_STATE_CANCELED]: "Canceled",
  [SubscriptionState.SUBSCRIPTION_STATE_INCOMPLETE]: "Incomplete",
  [SubscriptionState.SUBSCRIPTION_STATE_INCOMPLETE_EXPIRED]: "Incomplete Expired",
  [SubscriptionState.SUBSCRIPTION_STATE_ON_TRIAL]: "On Trial",
  [SubscriptionState.SUBSCRIPTION_STATE_PAST_DUE]: "Past Due",
  [SubscriptionState.SUBSCRIPTION_STATE_SUBSCRIBED]: "Subscribed",
  [SubscriptionState.SUBSCRIPTION_STATE_UNPAID]: "Unpaid",
  [SubscriptionState.SUBSCRIPTION_STATE_UNSPECIFIED]: "Unspecified",
};


